module.exports = __webpack_public_path__ + "static/media/Logo.bc631f85.png";